import OfficeSlides from './OfficeSlides'
import NeighborhoodSlides from './NeighborhoodSlides'

class BaseChanger {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el.querySelectorAll('[data-js="change-trigger"]');

    this.officeSlider = null;
    this.neighborhoodSlider = null;

    this.change = this.change.bind(this);
    this.show = this.show.bind(this);
    this.hidden = this.hidden.bind(this);
    this.scroll = this.scroll.bind(this);

    this.init();
  }

  init() {
    [...this.dom.trigger].forEach(el => {
      el.addEventListener('click', this.change);
    })

    const targetElm = document.querySelector(`[data-js="base"] [data-slug="main"]`);
    this.show(targetElm);
  }

  change(e) {
    this.scroll();

    const slug = e.currentTarget.dataset.slug;
    const hiddenElm = document.querySelector(`[data-js="base"] [data-is="show"]`);
    this.hidden(hiddenElm);
    
    const targetElm = document.querySelector(`[data-js="base"] [data-slug="${slug}"]`);
    this.show(targetElm);
  }
  
  show(target) {
    target.dataset.is = 'show';
    const domOfficeSlides = target.querySelector('[data-js="office-slide"]');
    if (domOfficeSlides) {
      this.officeSlider = new OfficeSlides(domOfficeSlides);
    }
  
    const domNeighborhoodSlides = target.querySelector('[data-js="neighborhood-slide"]');
    if (domNeighborhoodSlides) {
      this.neighborhoodSlider = new NeighborhoodSlides(domNeighborhoodSlides);
    }
  }

  hidden(target) {
    target.removeAttribute('data-is');
    if (this.officeSlider) this.officeSlider.destroy();
    if (this.neighborhoodSlider) this.neighborhoodSlider.destroy();
  }

  scroll() {
    const target = document.querySelector('#base');

    if (/pagetop/.test(this.hash)) {
      target.scrollIntoView({behavior:'smooth'});
    } else {
      // let hh = this.dom.header.clientHeight + 32;
      const rect = target.getBoundingClientRect().top;
      // 上に戻るときはナビが表示されるので、余白を作る
      let hh = (rect >= 0) ? 0 : 157;
      const pyo = window.pageYOffset;
      const top = rect + pyo - hh;
      // const top = rect + pyo;

      if (top == 0) {
        target.scrollIntoView({behavior:'smooth'});
      } else {
        window.scroll({top: top, behavior: 'smooth'});
      }
    }
  }
}

export default BaseChanger